import React, { useState } from 'react';
import { Button, intl, TextInput } from 'ehs-react';
import CommunicationUtil from '../util/CommunicationUtil';
import { usePortletStore } from '../App';

function AuthenticationWizardUpdateUserData({
  onNextPage
}: Readonly<{
  onNextPage: () => void;
}>): React.JSX.Element {
  const [initialFirstName, initialLastName] = usePortletStore(store => [
    store.configuration.referenceUserFirstName,
    store.configuration.referenceUserLastName
  ]);
  const [firstName, setFirstName] = useState(initialFirstName);
  const [lastName, setLastName] = useState(initialLastName);
  const [isRequestPending, setRequestPending] = useState(false);
  const ensureMaxLength = function (text: string, length: number): string {
    return text.length > length ? text.substr(0, length) : text;
  };
  return (
    <div>
      <p className="font-16 s-font">
        {intl(
          'patientSelfOnboardingPortlet.authenticationWizardUpdateUserDataPane.description'
        )}
      </p>
      <TextInput
        debounceWait={1000}
        label={intl('common.name.given')}
        value={firstName}
        onChange={firstName => setFirstName(ensureMaxLength(firstName, 75))}
        placeholder={intl(
          'patientSelfOnboardingPortlet.authenticationWizardUpdateUserDataPane.inputFirstNamePlaceholder'
        )}
        type="text"
        autoFocus={true}
      />
      <TextInput
        debounceWait={1000}
        label={intl('common.name.family')}
        value={lastName}
        onChange={lastName => setLastName(ensureMaxLength(lastName, 75))}
        placeholder={intl(
          'patientSelfOnboardingPortlet.authenticationWizardUpdateUserDataPane.inputLastNamePlaceholder'
        )}
        type="text"
      />
      <Button
        scale={'medium'}
        text={
          isRequestPending
            ? intl(
                'patientSelfOnboardingPortlet.authenticationWizard.buttonSaving'
              )
            : intl(
                'patientSelfOnboardingPortlet.authenticationWizardUpdateUserDataPane.buttonSave'
              )
        }
        disabled={isRequestPending}
        variant="primary"
        onClick={() =>
          CommunicationUtil.sendUpdateUserDataRequest(
            firstName,
            lastName,
            () => onNextPage(),
            (pending: boolean) => setRequestPending(pending)
          )
        }
      />
    </div>
  );
}

export default AuthenticationWizardUpdateUserData;
